import store_analyse from '@/store/mods/analyses/analyse'
import DateFilter from '@/components/date-filter';
import Manageprelevement from '@/views/tableau-de-bord/salle-prelevement/manage-prelevement'
import $ from 'jquery'

export default {
    name: 'salle-prelevement',
    components: {
        DateFilter, Manageprelevement
    },
    props: [],
    data() {
        return {
            liste_attente_prelevement: [],
            is_loading: true,
            is_empty: false,
            is_error: false,
            curr_page: 1,
            per_page: -1,
            total_pages: 0,
            filter: '',
            last_page: 0,
            goto_page: 1,
            search_term: '',
            from_index: 1,
            fields: [
                { key: 'reference', label: 'Référence' }, 
                { key: 'patient', label: 'Patient' }, 'sexe', 
                { key: 'telephone', label: 'Téléphone' },  { key: 'prescripteur', label: 'Prescripteur' }, 
                { key: 'analyses', label: 'Analyse.s' }, { key: 'actions', label: 'Actions' }
            ],

            current_date_filter: {},
            curr_month: "", 
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,

            all_checked: false,
            one_is_checked: [],
            toggler: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.is_month = true
            this.getListeAttentePrelevement()
        },

        filter() {
            if (this.filter == '') {
                this.current_date_filter.search_item = ''
                this.getListeAttentePrelevement()
            }
        }
    },

    computed: {

    },

    mounted() {
        const data = {
            month: "",
            one_date: this.getDates().today_date,
            from_date: "",
            to_date: ""
        }
        this.current_date_filter = data
        this.getListeAttentePrelevement()
    },

    methods: {
        getListeAttentePrelevement() {
            this.is_error = false
            this.is_loading = true 
            
            this.current_date_filter.page = this.goto_page,
            store_analyse.getListePatientAttentePrelevement(this.current_date_filter).then((response) => {
                this.liste_attente_prelevement = response.data
                this.last_page = response.last_page
                this.total_pages = response.last_page
                this.from_index = response.from

                if (this.liste_attente_prelevement.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },
        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                page: 1
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListeAttentePrelevement()
        },

        previousPage() {
            if (this.curr_page > 1) {
                this.curr_page--;
                this.goto_page = this.curr_page
                this.getListeAttentePrelevement()
            }
        },

        nextPage() {
            if (this.curr_page < this.total_pages) {
                this.curr_page++;
                this.goto_page = this.curr_page
                this.getListeAttentePrelevement()
            }
        },

        gotoPage(page) {
            if (page !== this.curr_page) {
                this.curr_page = page;
                this.goto_page = this.curr_page
                this.getListeAttentePrelevement()
            }
        },

        searchPatient() {
            this.current_date_filter.search_item = this.filter
            this.getListeAttentePrelevement()
        },

        toutSelectionner() {
            let is_checked = $('#all-bull').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.liste_attente_prelevement.forEach((data) => {
                    this.one_is_checked.push(data.bulletin_id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            this.choice_is_empty = false
            document.getElementById("all-bull").checked = false;
        },

        valider() {
            this.toggler = (this.toggler == 0)?1:0
            $('.mng-prelevement').modal('show')
        }
    }
}